"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavePhoneNumberRequestToJSON = exports.SavePhoneNumberRequestFromJSONTyped = exports.SavePhoneNumberRequestFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function SavePhoneNumberRequestFromJSON(json) {
    return SavePhoneNumberRequestFromJSONTyped(json, false);
}
exports.SavePhoneNumberRequestFromJSON = SavePhoneNumberRequestFromJSON;
function SavePhoneNumberRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': json['number'],
        'when': !(0, runtime_1.exists)(json, 'when') ? undefined : (0, _1.PhoneTimeFromJSON)(json['when']),
        'parcelShopSMS': !(0, runtime_1.exists)(json, 'parcelShopSMS') ? undefined : json['parcelShopSMS'],
    };
}
exports.SavePhoneNumberRequestFromJSONTyped = SavePhoneNumberRequestFromJSONTyped;
function SavePhoneNumberRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'number': value.number,
        'when': (0, _1.PhoneTimeToJSON)(value.when),
        'parcelShopSMS': value.parcelShopSMS,
    };
}
exports.SavePhoneNumberRequestToJSON = SavePhoneNumberRequestToJSON;
//# sourceMappingURL=SavePhoneNumberRequest.js.map